import React, { useState } from 'react'
import { appleWalletPasskit } from '../../../../api/UserRequest';
import { Button, Spin, message } from 'antd';
import appleWalletImg from "../../../../assests/images/AppleWallet.svg"
import { LoadingOutlined } from '@ant-design/icons';

function AddToAppleWallet({ cardID, ITxtColor, IColor }) {
    const [loading, setLoading] = useState(false);
    const [messageApi, contextHolder] = message.useMessage()
    const error = () => {
        messageApi.open({
            type: 'error',
            content: 'Some thing went wrong, please try after some time.',
        });
    };

    const handleAddToWallet = async () => {
        try {
            setLoading(true);
            const { data } = await appleWalletPasskit(cardID)
            if (data.success) {
                setLoading(false);
                const buffer = data.pkPass
                // console.log(buffer,'buffer');
                if (!buffer) {
                    return;
                }
                const byteArray = new Uint8Array(buffer.data);
                // console.log(byteArray,'byteArray');
                const blob = new Blob([byteArray], { type: 'application/vnd.apple.pkpass' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'pass.pkpass';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }

        } catch (err) {
            setLoading(false);
            error()
            console.log(err);
        }
    }

    return (
        <div>

            {/* <Button
                style={{
                    color: `${ITxtColor}`,
                    background: `${IColor}`,
                }}
                loading={loading}
                className='p-2 h-12 px-4 rounded-lg shadow-lg flex gap-3 cursor-pointer'
                onClick={handleAddToWallet}
            >

                <img src="https://zeeqr2.s3.ap-south-1.amazonaws.com/images/appleWalletIcon.webp" alt="" srcset="" />


                <div>
                    <p className='text-xs'>Add to</p>
                    <p className='text-xs font-semibold'>Apple Wallet</p>
                </div>

            </Button> */}

            <Spin spinning={loading} indicator={<LoadingOutlined spin />} size="small" >

                <img className='w-[160px] h-[48px] cursor-pointer' onClick={handleAddToWallet} src={appleWalletImg} alt="" srcset="" />
            </Spin>
           


            {contextHolder}
        </div>
    )
}

export default AddToAppleWallet